import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { USER_ROLE_ADMIN, USER_ROLE_AGENT } from 'common/userRoles';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import { placeholderProfilePicture } from 'common/apartmentLocatorHelpers';

import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import SrAgentLeaderboardBarChart from 'client/components/SrAgentLeaderboardBarChart';
import SrAgentLeaderboardCell from 'client/components/SrAgentLeaderboardCell';
import SrMonthlyFlicker from 'client/components/SrMonthlyFlicker';

import { SCREEN_ID_AGENT_LEADERBOARD } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles, { getUserLandingPage } from 'client/helpers/allowedRoles';
import branch from 'client/core/branch';
import AgentActions from 'client/actions/Agent';

@withTransitionHook
@withScrollToTop
@allowedRoles({
  roles: [USER_ROLE_ADMIN, USER_ROLE_AGENT],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_AGENT_LEADERBOARD)
@branch({
  currentUser: ['currentUser'],
  leaderboard: ['agent', 'leaderboard'],
})
class TourGuideLeaderboardPage extends Component {
  static fetchData(match, inject) {
    const startDate = momentWithAustinTimezone().startOf('month').toISOString();
    const endDate = momentWithAustinTimezone().endOf('month').toISOString();
    return AgentActions.getLeaderboard(inject, { startDate, endDate });
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    leaderboard: PropTypes.array.isRequired,
  };

  _onMonthUpdated = (startDate, endDate) => {
    const { dispatch } = this.props;
    dispatch(AgentActions.getLeaderboard, {
      startDate,
      endDate,
    });
  };

  render() {
    const { currentUser, leaderboard } = this.props;
    if (!leaderboard || leaderboard.length < 3) {
      return null;
    }

    return (
      <div className="page-agent-leaderboard">
        <Navbar
          redirectLogoTo={getUserLandingPage({ userRoles: currentUser.roles })}
          leftButton={
            <SrLink
              className="link back"
              redirectToLastLocation
              restoreScrollPosition
              to="/agent/tour-guide-profile"
            >
              Back
            </SrLink>
          }
        />
        <SrMonthlyFlicker
          title="Leaderboard"
          onMonthUpdated={(startDate, endDate) => this._onMonthUpdated(startDate, endDate)}
        />
        <div className="barChartContainer">
          <SrAgentLeaderboardBarChart
            firstPlaceProfilePictureUrl={
              leaderboard[0].agent.profilePicture || placeholderProfilePicture
            }
            secondPlaceProfilePictureUrl={
              leaderboard[1].agent.profilePicture || placeholderProfilePicture
            }
            thirdPlaceProfilePictureUrl={
              leaderboard[2].agent.profilePicture || placeholderProfilePicture
            }
          />
        </div>
        <div className="leaderboardSpacing" />
        <div className="leaderboardContainer">
          {leaderboard.map((row, index) => (
            <SrAgentLeaderboardCell
              key={row.agent.id}
              rank={index + 1}
              profilePictureUrl={row.agent.profilePicture || placeholderProfilePicture}
              agentName={row.agent.name}
              leaseVolume={parseInt(row.leasesSigned, 10)}
            />
          ))}
        </div>
      </div>
    );
  }
}

TourGuideLeaderboardPage.displayName = 'TourGuideLeaderboardPage';

export default TourGuideLeaderboardPage;
